import { render } from "./ValidateTextarea.vue?vue&type=template&id=b3110a94"
import script from "./ValidateTextarea.vue?vue&type=script&lang=js"
export * from "./ValidateTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__